// src/parse/parse-error.ts
var ParseErrorCode = {
  LoadFail: 0,
  BadSignature: 1,
  BadTimestamp: 2,
  BadSettingValue: 3,
  BadFormat: 4,
  UnknownSetting: 5
};
var ParseError = class extends Error {
  constructor(init) {
    super(init.reason);
    this.code = init.code;
    this.line = init.line;
  }
};

export {
  ParseErrorCode,
  ParseError
};
